/**
 * Aviso visible cuando falla anadir al carrito.
 *
 * El flujo Ajax del tema restablece el estado del boton cuando la peticion a
 * /cart/add falla, pero no muestra ningun mensaje: el comprador hace clic, no
 * pasa nada y no sabe por que. Este interceptor reutiliza el sistema de avisos
 * propio del tema (T4SThemeSP.Notices) para que el error sea visible, sin tocar
 * los bundles minificados del tema.
 *
 * Va en un asset propio, y no en custom.js, porque ese archivo solo se carga si
 * el ajuste t4s_custom_js esta activado y hoy esta apagado.
 */
(function () {
  'use strict';

  var ULTIMO_AVISO = 0;

  function mensaje() {
    return (window.T4SProductStrings && window.T4SProductStrings.addToCartError) ||
      'No pudimos agregar el producto al carrito. Revisa tu conexion e intentalo de nuevo.';
  }

  function avisar() {
    var ahora = Date.now();
    if (ahora - ULTIMO_AVISO < 1500) return; // evita avisos repetidos por reintentos
    ULTIMO_AVISO = ahora;

    if (window.T4SThemeSP && typeof window.T4SThemeSP.Notices === 'function') {
      window.T4SThemeSP.Notices(mensaje(), 'error');
      return;
    }
    // Respaldo por si el sistema de avisos del tema aun no esta disponible
    var el = document.createElement('div');
    el.setAttribute('role', 'alert');
    el.textContent = mensaje();
    el.style.cssText = 'position:fixed;bottom:20px;left:50%;transform:translateX(-50%);' +
      'background:#c0392b;color:#fff;padding:12px 20px;border-radius:6px;z-index:99999;' +
      'font-size:14px;max-width:90vw;text-align:center;box-shadow:0 2px 12px rgba(0,0,0,.25)';
    document.body.appendChild(el);
    setTimeout(function () { el.remove(); }, 6000);
  }

  function esAltaDeCarrito(url) {
    return typeof url === 'string' && url.indexOf('/cart/add') !== -1;
  }

  if (window.fetch) {
    var fetchOriginal = window.fetch;
    window.fetch = function (recurso) {
      var url = typeof recurso === 'string' ? recurso : (recurso && recurso.url);
      var vigilar = esAltaDeCarrito(url);
      return fetchOriginal.apply(this, arguments).then(function (res) {
        if (vigilar && !res.ok) avisar();
        return res;
      }).catch(function (err) {
        if (vigilar) avisar();
        throw err;
      });
    };
  }

  // El tema tambien usa jQuery.ajax, que va por XMLHttpRequest
  var abrirOriginal = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (metodo, url) {
    this.__t4sCartAdd = esAltaDeCarrito(url);
    return abrirOriginal.apply(this, arguments);
  };
  var enviarOriginal = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function () {
    var xhr = this;
    if (xhr.__t4sCartAdd) {
      xhr.addEventListener('load', function () {
        if (xhr.status < 200 || xhr.status >= 300) avisar();
      });
      xhr.addEventListener('error', avisar);
      xhr.addEventListener('timeout', avisar);
    }
    return enviarOriginal.apply(this, arguments);
  };
})();
